import React from 'react';
import WorkSpace from './workspace.js';
import LoginScreen from './login-screen.js';
import ResetPassScreen from './resetpass-screen.js';
import MobileUploadScreen from './mobile-upload.js';
import MobileUploadDocScreen from './mobile-upload-doc.js';


export default class Main extends React.Component { 

    constructor(props) {
        super(props);
       
    }    

    componentDidMount() {
    }


    state = {
        isAuthorized: false,
        isNeedReset: false
    };

    onLoginSuccess() {
        this.setState({isAuthorized: true})
    }

    onNeedPassReset() {
        this.setState({isAuthorized: false, isNeedReset: true})
    }

    onPassResetSuccess() {
        this.setState(({isAuthorized: true, isNeedReset: false}))
    }

     getMobileUploadToken() {
        const path = window.location.pathname;
        const params = new URLSearchParams(window.location.search);

        if (path === "/mobile-upload" || path == "/mobile-upload-doc") {
            return params.get("token");
        }

        return null;
    }

    render() { 

        const mobileUploadToken = this.getMobileUploadToken();

        if (mobileUploadToken && window.location.pathname === "/mobile-upload") {
            return <MobileUploadScreen token={mobileUploadToken} />;
        }

        if (mobileUploadToken && window.location.pathname === "/mobile-upload-doc") {
            return <MobileUploadDocScreen token={mobileUploadToken} />;
        }

        return (
            <div>
                {this.state.isAuthorized && <WorkSpace/>}

                {!this.state.isAuthorized && !this.state.isNeedReset && <LoginScreen onSuccess={this.onLoginSuccess.bind(this)} onNeedPassReset={this.onNeedPassReset.bind(this)}/>}    

                {this.state.isNeedReset && <ResetPassScreen onResetSuccess={this.onPassResetSuccess.bind(this)}/>}

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/main.js